import React from 'react'
import Header from '../component/Header'
import { Helmet } from 'react-helmet'

const Home = () => {
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Infraestructura natural para recuperar las fuentes de agua</title>
        <link rel="canonical" href="https://fundacionmohme.org/especiales/infraestructura-natural-recuperar-fuentes-agua" />
        <meta property="og:url" data-react-helmet="true" content="https://fundacionmohme.org/especiales/infraestructura-natural-recuperar-fuentes-agua" />
				<meta name="description" data-react-helmet="true" content="Proyecto Infraestructura Natural para la Seguridad Hídrica, en alianza con la Fundación Gustavo Mohme Llona." />
				<meta property="og:description" data-react-helmet="true" content="Proyecto Infraestructura Natural para la Seguridad Hídrica, en alianza con la Fundación Gustavo Mohme Llona." />
				<meta property="og:title" data-react-helmet="true" content="Infraestructura natural para recuperar las fuentes de agua" />
      </Helmet>
      
      <Header />
    </div>
  )
}

export default Home
